import {IonBackButton, IonButton, IonButtons, IonIcon, isPlatform, useIonRouter} from "@ionic/react";
import {useModalContext} from "app/employee/incdoc/FstIonModal";
import {arrowBackOutline} from "ionicons/icons";
import {logoIcon} from "app/utils/icons/ionicFixedIcons";

export const HomeBackButton = () => {
  const ionRouter = useIonRouter();
  const modalContext = useModalContext();

  if (modalContext) {
    return (
      <IonButtons slot="start">
        <IonButton fill="clear" onClick={() => modalContext.dismiss()}>
          <IonIcon icon={arrowBackOutline} slot="icon-only" />
        </IonButton>
      </IonButtons>
    );
  } else {
    if (ionRouter.routeInfo.pushedByRoute) {
      const backButtonText = isPlatform("ios") ? "" : undefined; // returns true when running on a iOS device
      return (
        <IonButtons slot="start">
          <IonBackButton text={backButtonText} />
        </IonButtons>
      );
    } else {
      return <IonIcon className="ion-padding-start" icon={logoIcon} size="large" slot="start" />;
    }
  }
};
